import React, { useEffect, useState } from 'react'
import ReactDom from 'react-dom'
import get from 'lodash/get'
import isEmpty from 'lodash/isEmpty'
import copyToClipboard from 'copy-to-clipboard';
import { Table, Input, Popup, Button, Icon, Confirm, Message } from 'semantic-ui-react'

import '../less/listMaps.less'

function ListMaps(props) {

    const [maps, setMaps] = useState(get(window, 'webbymaps.data.maps', []))
    return (
        <div id="list-maps">
            <h2 id="title">List All Maps</h2>
            <NotificationsBar {...props} />
            <TableMaps maps={maps} setMaps={setMaps} {...props} />
        </div>
    )
}

ReactDom.render(<ListMaps />, document.getElementById('root'))

function NotificationsBar(props) {
    const successNotifications = get(window, 'webbymaps.data.successNotifications', [])
    return (
        <div id="notifications-bar">
            {!isEmpty(successNotifications) &&
                successNotifications.map((itemNotification, n) =>
                    <Message key={n} positive>
                        <p>{itemNotification}</p>
                    </Message>)
            }
        </div>
    )
}

function TableMaps(props) {
    const maps = get(props, 'maps')
    return (
        <Table fixed>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell width={1}>#</Table.HeaderCell>
                    <Table.HeaderCell>Map Name</Table.HeaderCell>
                    <Table.HeaderCell>Shortcode</Table.HeaderCell>
                    <Table.HeaderCell width={1}>Action</Table.HeaderCell>
                </Table.Row>
            </Table.Header>

            <Table.Body>
                {isEmpty(maps) &&
                    <Table.Row>
                        <Table.Cell></Table.Cell>
                        <Table.Cell colSpan={3}>
                            You don't have any maps yet. <br /> &#8212; <a href={`${get(window, 'webbymaps.data.adminUrl')}?page=webby-maps-add`}>Create New</a>
                        </Table.Cell>
                    </Table.Row>
                }

                {maps.map((mapItem, m) =>
                    <TableRow key={m} index={m} mapItem={mapItem} {...props} />
                )}

            </Table.Body>
        </Table>
    )
}

function TableRow(props) {
    const handleClickCopyToClipboard = () => {
        const shortcode = get(props, 'mapItem.shortcode')
        copyToClipboard(shortcode)
    }
    return (
        <Table.Row>
            <Table.Cell>{get(props, 'index') + 1}</Table.Cell>
            <Table.Cell>
                <a className='row-title' href={`${get(window, 'webbymaps.data.adminUrl')}?page=webby-maps&subpage=edit-map&mapid=${get(props, 'mapItem.id')}`}>{get(props, 'mapItem.name')}</a>
            </Table.Cell>
            <Table.Cell>
                <Input
                    action={<Popup
                        inverted
                        size='tiny'
                        content='Copied!'
                        on='click'
                        pinned
                        hideOnScroll
                        trigger={<Button icon="copy" onClick={handleClickCopyToClipboard} title="Copy shortcode" />}
                    />}
                    value={get(props, 'mapItem.shortcode')}
                />
            </Table.Cell>

            <TableCellAction {...props} />
        </Table.Row>
    )
}

function TableCellAction(props) {
    const [openModal, setOpenModal] = useState(false)

    const handleConfirmDelete = mapId => () => {
        const adminUrl = get(window, 'webbymaps.data.adminUrl')

        const form = document.createElement("form");
        document.body.appendChild(form);
        form.method = "POST";
        form.action = `${adminUrl}?page=webby-maps&subpage=delete-map&mapid=${mapId}`;
        const element1 = document.createElement("input");
        element1.name = "mapid"
        element1.value = mapId;
        element1.type = 'hidden'
        form.appendChild(element1);
        form.submit();

        // window.location.href = `${adminUrl}?page=webby-maps&subpage=delete-map&mapid=${mapId}`
    }

    return (
        <Table.Cell>
            <Button basic icon title="Delete" onClick={() => setOpenModal(true)}>
                <Icon name="trash alternate outline" color="red" />
            </Button>
            <Confirm
                open={openModal}
                content={`Are you sure you want to delete ${get(props, 'mapItem.name')}?`}
                cancelButton='Cancel'
                confirmButton="Yes"
                onCancel={() => setOpenModal(false)}
                onConfirm={handleConfirmDelete(get(props, 'mapItem.id'))}
            />
        </Table.Cell>
    )
}